import client from './axiosClient';
export const login         = dto  => client.post('/auth/login', dto);
export const forgotPassword= dto  => client.post('/auth/forgot-password', dto);
export const resetPassword = dto  => client.post('/auth/reset-password', dto);
